import React from "react";

/**
 * ClientExchange – Legal & Policies Page (Updated v1.9)
 * Model: Seller-pays Carsales-style marketplace
 * Jurisdiction: Australia (ACL-aligned)
 * © 2025 ClientExchange Pty Ltd
 */

export default function Legal() {
  return (
    <div style={{ background: "#f8fafc", minHeight: "100vh", padding: "40px 16px" }}>
  <div style={{ maxWidth: "1000px", margin: "0 auto", color: "#1e293b" }}>
      <header className="mb-10">
        <h1 className="text-3xl font-bold text-emerald-700">Legal & Policies</h1>
        <p className="mt-2 text-sm text-slate-600">
         Last updated: 27 October 2025 · Client Exchange Pty Ltd (ABN 23 692 732 157)
        </p>
      </header>

      {/* Navigation */}
      <nav className="mb-8 grid gap-2 sm:grid-cols-2">
        <a href="#tos" className="rounded-xl bg-emerald-50 p-4 hover:bg-emerald-100">
          <div className="font-semibold">1. Terms of Service</div>
          <div className="text-sm text-slate-600">Overview & acceptance</div>
        </a>
        <a href="#buyers" className="rounded-xl bg-emerald-50 p-4 hover:bg-emerald-100">
          <div className="font-semibold">2. Buyer Terms</div>
          <div className="text-sm text-slate-600">Contact access & use</div>
        </a>
        <a href="#sellers" className="rounded-xl bg-emerald-50 p-4 hover:bg-emerald-100">
          <div className="font-semibold">3. Seller Terms</div>
          <div className="text-sm text-slate-600">Listing accuracy & obligations</div>
        </a>
        <a href="#fees" className="rounded-xl bg-emerald-50 p-4 hover:bg-emerald-100">
          <div className="font-semibold">4. Listing Fees & Refund Policy</div>
          <div className="text-sm text-slate-600">Non-refundable advertising fees</div>
        </a>
        <a href="#privacy" className="rounded-xl bg-emerald-50 p-4 hover:bg-emerald-100">
          <div className="font-semibold">5. Privacy & Data</div>
          <div className="text-sm text-slate-600">Handling of contact & identity info</div>
        </a>
        <a href="#contact" className="rounded-xl bg-emerald-50 p-4 hover:bg-emerald-100">
          <div className="font-semibold">6. Contact & Complaints</div>
          <div className="text-sm text-slate-600">How to reach us</div>
        </a>
      </nav>

   

      {/* 2. Buyer Terms */}
      <section id="buyers" className="mb-12">
        <h2 className="mb-3 text-2xl font-semibold text-emerald-700">2. Buyer Terms</h2>
        <ol className="list-decimal space-y-2 pl-6">
          <li>
            <span className="font-semibold">Access to Seller Details.</span> Buyers may browse listings free of charge.
            When a buyer selects “Buy” or “Request Contact,” ClientExchange will email the buyer with the seller’s
            registered contact details (name, email, and optional phone number) solely to enable direct communication.
          </li>
          <li>
            <span className="font-semibold">Use of Information.</span> Buyer access to seller details is limited to
            legitimate transaction discussions only. Buyers must not use seller information for marketing,
            solicitation, or platform circumvention.
          </li>
          <li>
            <span className="font-semibold">Platform Role.</span> After contact details are shared, all negotiations and
            agreements occur directly between buyer and seller. ClientExchange is not responsible for outcomes or disputes.
          </li>
        </ol>
      </section>

      {/* 3. Seller Terms */}
      <section id="sellers" className="mb-12">
        <h2 className="mb-3 text-2xl font-semibold text-emerald-700">3. Seller Terms (Obligations & Listing Accuracy)</h2>
        <ol className="list-decimal space-y-2 pl-6">
          <li>
            <span className="font-semibold">Accuracy & Authority.</span> Sellers warrant that all listing information
            (including client numbers, revenue, frequency, and service area) is accurate and not misleading.
            Sellers confirm they have full authority to sell or transfer the listed client relationship.
          </li>
          <li>
            <span className="font-semibold">Listing Duration.</span> Paid listings remain active for the advertised period
            (e.g. 30 days) unless removed for policy breach or withdrawn early by the seller.
          </li>
          <li>
            <span className="font-semibold">Withdrawal & Conduct.</span> Sellers may remove listings at any time;
            however, listing fees are non-refundable once published. Repeated breaches may result in account suspension.
          </li>
          <li>
            <span className="font-semibold">Buyer Contact Disclosure.</span> Sellers consent to their registered contact
            details being shared with verified buyers who request contact.
          </li>
        </ol>
      </section>

      {/* 4. Listing Fees & Refund Policy */}
            {/* 4. Fees, Payments & Refund Policy */}
            {/* 4. Fees, Payments & Refund Policy */}
      <section id="fees" className="mb-12">
        <h2 className="mb-3 text-2xl font-semibold text-emerald-700">4. Fees, Payments & Refund Policy</h2>
        <div className="space-y-4">

                    <h3 className="font-semibold">4.1 Listing Sale Fees (Cleaning & Lawn Mowing Clients)</h3>
          <ul className="list-disc pl-6">
            <li>For Cleaning and Lawn Mowing <span className="font-semibold">client listings</span>, a <span className="font-semibold">seller listing fee equal to 25%</span> of the agreed sale price is payable upfront when the seller lists the clients for sale.</li>
            <li>This seller fee covers platform access, listing visibility, and transaction facilitation services.</li>
            <li>The seller listing fee is <span className="font-semibold">non-refundable</span> once the listing is published.</li>
          </ul>

                    <h3 className="font-semibold">4.2 Buyer Purchase Fees (Client Sales)</h3>
          <ul className="list-disc pl-6">
            <li>The buyer pays the <span className="font-semibold">full agreed purchase price</span> for the clients, plus an additional <span className="font-semibold">15% administration fee</span> as displayed at checkout.</li>
            <li>The administration fee covers payment processing, platform operations, and transaction coordination.</li>
          </ul>

                    <h3 className="font-semibold">4.3 Payment Handling & Handover (Client Sales)</h3>
          <ul className="list-disc pl-6">
            <li>Buyer funds are collected via ClientExchange’s payment processor and held pending completion of the handover process.</li>
           <li>
  Once handover is confirmed (or automatically completed in accordance with platform rules),
  the seller payout is released in accordance with the applicable listing and platform fee structure.
</li>
            <li>ClientExchange is not a trust or escrow service and does not guarantee the outcome of any transaction.</li>
          </ul>

                    <h3 className="font-semibold">4.4 Swap Fees</h3>
          <ul className="list-disc pl-6">
            <li>
  Swap transactions attract a
  <span className="font-semibold"> fixed swap service fee</span>
  (currently AUD $79.00 per party, subject to change and displayed at checkout).
</li>
            <li>The swap fee becomes payable <span className="font-semibold">only after the first party accepts a swap request</span>.</li>
            <li>Each party must pay their own swap fee for the swap to proceed.</li>
          </ul>

          <h3 className="font-semibold">4.5 Business & Round Listings</h3>
          <ul className="list-disc pl-6">
            <li>Business and round listings are subject to a <span className="font-semibold">fixed listing fee of AUD $218.90</span>.</li>
            <li>The listing fee covers a <span className="font-semibold">six (6) month listing period</span>.</li>
            <li>Listings may be renewed for additional six-month periods upon payment of the applicable renewal fee.</li>
            <li>Business and franchise listing fees are <span className="font-semibold">non-refundable</span> once the listing is published.</li>
          </ul>

                    <h3 className="font-semibold">4.6 No Refunds</h3>
          <ul className="list-disc pl-6">
            <li>Seller listing fees, buyer administration fees, and swap service fees are <span className="font-semibold">non-refundable</span> once paid, except where required by law.</li>
            <li>ClientExchange does not guarantee a successful sale, swap completion, or ongoing client retention.</li>
          </ul>

          <h3 className="font-semibold">4.6 Off-Platform Transactions</h3>
          <ul className="list-disc pl-6">
            <li>All negotiations and transactions occur directly between buyers and sellers.</li>
            <li>ClientExchange does not mediate, enforce, or refund off-platform agreements.</li>
          </ul>
        </div>
      </section>

      {/* 5. Privacy */}
      <section id="privacy" className="mb-12">
        <h2 className="mb-3 text-2xl font-semibold text-emerald-700">5. Privacy & Data Handling</h2>
        <p className="mb-3">
          ClientExchange collects only information necessary to operate the marketplace, including user profiles,
          listings, contact disclosures, verification status, and limited metadata from third-party providers.
        </p>
        <p>
  ClientExchange uses a third-party identity verification provider (Stripe Identity)
  to assist in confirming user identity. Identity documents (such as driver’s licences or passports)
  may be processed securely by the provider, including biometric checks where required.
</p>
        <p>
  ClientExchange does not collect, access, or store identity documents directly. Only the verification result
  (e.g. verified / not verified) and a reference identifier are retained.
</p>

<p>
  Identity verification helps improve trust on the platform but does not guarantee the identity, legitimacy, or conduct of any user.
</p>
        <ul className="list-disc pl-6">
          <li>Contact details are disclosed only to verified buyers for transaction purposes.</li>
          <li>Audit logs are maintained for fraud prevention and dispute review.</li>
          <li>Data is secured at rest and in transit in accordance with Australian Privacy Principles.</li>
        </ul>
      </section>

      {/* 6. Contact */}
      <section id="contact" className="mb-12">
        <h2 className="mb-3 text-2xl font-semibold text-emerald-700">6. Contact & Complaints</h2>
        <p className="mb-2">Client Exchange Pty Ltd</p>
<p className="text-sm text-slate-600">ABN 23 692 732 157</p>
        <p className="text-sm text-slate-600">Support: support@clientexchange.com.au</p>
        <p className="text-sm text-slate-600">Please include your Listing ID when contacting support.</p>
      </section>

      <footer className="mt-10 border-t pt-6 text-xs text-slate-500">
        This document summarises key platform terms and does not constitute legal advice.
        Seek independent legal advice if required. © {new Date().getFullYear()} ClientExchange Pty Ltd.
      </footer>
    </div>
  </div>
    );
}


